module.exports = __webpack_public_path__ + "img/20170319-4.d31054cc.jpeg";